import { MessageComponent } from '@syncfusion/ej2-react-notifications';
import RichTextEditorControl from './RichTextEditorControl';
import React, { useState, useEffect } from 'react';
import { createSpinner, showSpinner } from '@syncfusion/ej2-popups';
import Error from '../Error';
import { storePurpose, providePurpose } from "../../utils/Purpose";
import { get } from "../../utils/Api";
import { env } from '../../env'

export default function TemplateEditor(props) {
    // Declare variables using const or let
    const { purposeId, formTemplateId, provider, setValue, errors, templateNeedsChanging, replacementValues, allowEditing } = props; 
    let spinnerInstance = null;
    // Declare state variables using useState
    const [isTemplateLoaded, setIsTemplateLoaded] = useState(false);
    const [isTemplateLoading, setIsTemplateLoading] = useState(false);
    const [template, setTemplate] = useState('');
    const [templateVersion, setTemplateVersion] = useState(0)

    const [templateState, setTemplateState] = useState({
        originalTemplate: null,
        templateErrorMessage: '',
        templateError: false
    });


    useEffect(() => {
        if (env.VITE_ENV && env.VITE_ENV.toLowerCase() !== 'production') {
            console.log(`TemplateEditor.useEffect :: default`);
        }

        const handleTemplateLoad = async () => {
            if (env.VITE_ENV && env.VITE_ENV.toLowerCase() !== 'production') {
                console.log(`TemplateEditor.handleTemplateLoad`);
            }

            setIsTemplateLoading(true);

            const response = await get(`${provider.url}/api/v1.0/forms/template?cfk=${encodeURIComponent(provider.key)}&id=${formTemplateId}`);
            if (response.status === 200) {
                setTemplateState((prevFormData) => ({ ...prevFormData, originalTemplate: response.data, templateError: false, templateErrorMessage: "" }));
                processTemplate(response.data)

            } else {
                setIsTemplateLoading(false);
                setTemplateState((prevFormData) => ({ ...prevFormData, templateError: true, templateErrorMessage: "Unable to find template, please try again." }));
            }
        };

        if (!isTemplateLoading) {
            if (!templateNeedsChanging && template !== null && template !== '') {
                setIsTemplateLoaded(true);
            }
            else if (!templateNeedsChanging && (template === null || template === '')) {
                let storedTemplate = providePurpose(`df.${formTemplateId}.let`, purposeId);
                if (storedTemplate !== null && storedTemplate !== '') {
                    processTemplate(storedTemplate);                    
                } else {
                    handleTemplateLoad();
                }
            } else {
                handleTemplateLoad();
            }
        }
    }, [templateNeedsChanging, replacementValues])

    useEffect(() => {
        if (env.VITE_ENV && env.VITE_ENV.toLowerCase() !== 'production') {
            console.log(`TemplateEditor.useEffect :: isTemplateLoading: ${isTemplateLoading}`);
        }

        if (isTemplateLoading && spinnerInstance) {
            createSpinner({
                // Specify the target for the spinner to show
                target: spinnerInstance,
            });
            showSpinner(spinnerInstance);
        }
    }, [isTemplateLoading, spinnerInstance])

    // Declare event handlers or other functions
    const handleForceUpdate = () => {
        // Incrementing the key will force the RichTextEditorComponent to remount
        setTemplateVersion((prevKey) => prevKey + 1);
    };

    const processTemplate = (args) => {
        if (args !== null) {
            let parsedTemplate = args;
            replacementValues.forEach(item => {
                parsedTemplate = parsedTemplate.replace(item.key, item.value || '');
            });

            setTemplate(parsedTemplate);
            storePurpose(`df.${formTemplateId}.let`, parsedTemplate, purposeId);
            handleForceUpdate();
            setIsTemplateLoaded(true);
            setIsTemplateLoading(false);
        }
    }

    // Render JSX using state variables and other variables
    return (
        <div>
            <div className="container mt-2">
                <div className="col-xs-12 text-label-row">
                    <b className="example-label">Letter:</b>
                </div>
                <div className="row">
                    <div className="col-xs-12" style={!isTemplateLoading && templateState.templateError ? {} : { display: 'none' }}>
                        <MessageComponent severity="Warning" variant="Filled" content={templateState.templateErrorMessage}></MessageComponent >
                    </div>

                    <div className="col-xs-12" style={isTemplateLoading ? {} : { display: 'none' }}>
                        <div ref={spinner => {
                            spinnerInstance = spinner;
                        }} id="spinner" />
                    </div>

                    <div className="col-xs-12 mt-1" style={isTemplateLoaded && !isTemplateLoading && template !== '' ? {} : { display: 'none' }} >
                        <RichTextEditorControl id={formTemplateId} purposeId={purposeId} name="template" label={templateVersion} setValue={setValue} defaultValue={template} refresh={true} height="70vh" allowEditing={allowEditing} />
                        {errors.template && <Error>{errors.template.message ? errors.template.message : "* Please enter your letter."}</Error>}
                    </div>
   
                    <div className="col-xs-12 mt-2" style={isTemplateLoaded ? {} : { display: 'none' }}>
                        <MessageComponent severity="Info" variant="Outline" content="Your name, email and address will be appended to the template at the end."></MessageComponent >
                    </div>
                </div>
            </div>
        </div>
    );
};